/* Swatch trigger label: keep "Clip Only" bold when the label is re-rendered by JS */
window.hgSwatchLabelHTML = function(text) {
  return String(text == null ? '' : text)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/Clip Only/g, '<strong>$&</strong>');
};
(function() {
  /* Данные, которые умеет посчитать только Liquid, приезжают из
     <script type="application/json" id="hg-swatch-data"> в main-product.liquid.
     Тот же приём, что у product-variants-json в этом же шаблоне. */
  var _hgEl = document.getElementById('hg-swatch-data');
  var _hgSwatchData = {};
  try { if (_hgEl) _hgSwatchData = JSON.parse(_hgEl.textContent); } catch (e) {}
  var productImages  = _hgSwatchData.images     || [];
  var mediaTypes     = _hgSwatchData.mediaTypes || [];
  var mediaVideoSrcs = _hgSwatchData.videoSrcs  || [];
  var imageAlts      = _hgSwatchData.alts       || [];
  window.modalImageIndex = 0;
  function getNextVisibleModal(from, dir) {
    var thumbs = document.querySelectorAll('.colorVariant');
    if (!thumbs.length) return from;
    var n = thumbs.length;
    for (var step = 1; step <= n; step++) {
      var idx = (from + dir * step + n) % n;
      if (thumbs[idx] && thumbs[idx].style.display !== 'none') return idx;
    }
    return from;
  }
  function updateModalNav() {
    var bl = document.getElementById('modalBtnLeft');
    var br = document.getElementById('modalBtnRight');
    var thumbs = document.querySelectorAll('.colorVariant');
    if (!thumbs.length || !bl || !br) return;
    
    var hasPrev = false;
    for (var i = 0; i < window.modalImageIndex; i++) {
      if (thumbs[i].style.display !== 'none') { hasPrev = true; break; }
    }
    var hasNext = false;
    for (var i = window.modalImageIndex + 1; i < thumbs.length; i++) {
      if (thumbs[i].style.display !== 'none') { hasNext = true; break; }
    }
    bl.disabled = !hasPrev;
    br.disabled = !hasNext;
  }
  function preloadModalImages(centerIndex) {
    var thumbs = document.querySelectorAll('.colorVariant');
    var n = productImages.length;
    var seen = {};
    seen[centerIndex] = true;
    var queue = [centerIndex];
    for (var step = 1; step <= n; step++) {
      var nxt = (centerIndex + step) % n;
      var prv = (centerIndex - step + n) % n;
      if (!seen[nxt] && thumbs[nxt] && thumbs[nxt].style.display !== 'none') { queue.push(nxt); seen[nxt] = true; }
      if (!seen[prv] && thumbs[prv] && thumbs[prv].style.display !== 'none') { queue.push(prv); seen[prv] = true; }
    }
    queue.forEach(function(idx) {
      if (productImages[idx]) (new Image()).src = productImages[idx];
    });
  }

  function showModalMedia(index) {
    var img = document.getElementById('modalImage');
    var vid = document.getElementById('modalVideo');
    var type = mediaTypes && mediaTypes[index];
    if (type === 'video' && vid) {
      if (img) { img.style.display = 'none'; }
      var vsrc = mediaVideoSrcs[index] || '';
      if (vsrc && vid.dataset.loadedSrc !== vsrc) {
        vid.src = vsrc;
        vid.dataset.loadedSrc = vsrc;
        vid.poster = productImages[index] || '';
        vid.load();
      }
      vid.style.display = 'block';
    } else {
      if (vid) { vid.pause(); vid.style.display = 'none'; }
      if (img) {
        img.style.display = 'block';
        img.src = productImages[index] || '';
        img.alt = imageAlts[index] || '';
      }
    }
  }
  window.openImageModal = function() {
    var modal = document.getElementById('imageModal');
    if (modal) {
      window.modalImageIndex = window.galleryCurrentIndex || 0;
      showModalMedia(window.modalImageIndex);
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      updateModalNav();
      preloadModalImages(window.modalImageIndex);
    }
  };
  window.closeImageModal = function() {
    var m = document.getElementById('imageModal');
    if (m) { m.style.display = 'none'; document.body.style.overflow = ''; }
    var vid = document.getElementById('modalVideo');
    if (vid) { vid.pause(); }
  };
  window.modalPrevImage = function() {
    var next = getNextVisibleModal(window.modalImageIndex, -1);
    if (next === window.modalImageIndex) return;
    window.modalImageIndex = next;
    showModalMedia(window.modalImageIndex);
    updateModalNav();
  };
  window.modalNextImage = function() {
    var next = getNextVisibleModal(window.modalImageIndex, 1);
    if (next === window.modalImageIndex) return;
    window.modalImageIndex = next;
    showModalMedia(window.modalImageIndex);
    updateModalNav();
  };
  var ROW_ORDER = ['horizontal lens', 'vertical lens', 'bridge', 'effective lens diameter', 'temple length', 'frame width'];
  function sizeRowOrder(label) {
    var l = (label || '').toLowerCase();
    for (var i = 0; i < ROW_ORDER.length; i++) { if (l.indexOf(ROW_ORDER[i]) !== -1) return i; }
    return 50;
  }
  function getSelectedOptionVal(labelName) {
    var result = null;
    document.querySelectorAll('.variantOption').forEach(function(opt) {
      var lbl = opt.querySelector('label');
      if (!lbl || lbl.textContent.trim() !== labelName) return;
      var selBtn = opt.querySelector('.variantPillBtnSelected');
      if (selBtn) { result = selBtn.getAttribute('data-value'); return; }
      var sel = opt.querySelector('.variantSwatchSelect');
      if (sel && sel.value) result = sel.value;
    });
    return result;
  }
  function findSrcSizeTable() {
    var found = null;
    document.querySelectorAll('.accordionContent').forEach(function(acc) {
      if (!found) { var t = acc.querySelector('.size_table'); if (t) found = t; }
    });
    return found;
  }
  /* --- Size Guide helpers --- */

  /* Extract "Size XX" number from H1 text, e.g. "Ranger | Size 72" → "72" */
  function getSizeFromH1() {
    var h1 = document.querySelector('h1');
    if (!h1) return null;
    var m = h1.textContent.match(/\bSize\s+(\d+)/i);
    return m ? m[1] : null;
  }

  /* Find column index in size_table header that matches a given size value */
  function findColIdx(headerCells, size) {
    for (var i = 1; i < headerCells.length; i++) {
      var b = headerCells[i].querySelector('b');
      var v = b ? b.textContent.trim() : headerCells[i].textContent.replace(/\s+/g, ' ').trim();
      if (v === String(size).trim()) return i;
    }
    return -1;
  }

  /* Remove trailing colon from a label; keep letter suffixes like ", A", ", B" */
  function cleanLabel(raw) { return raw.replace(/:\s*$/, ''); }

  /* Render data rows of a size_table column into HTML <tr> strings */
  function renderTableCol(rows, colIdx, temple) {
    var data = [];
    for (var i = 1; i < rows.length; i++) {
      var cells = Array.from(rows[i].querySelectorAll('td'));
      if (!cells.length) continue;
      data.push({ order: sizeRowOrder(cells[0].textContent), cells: cells });
    }
    data.sort(function(a, b) { return a.order - b.order; });
    return data.map(function(row) {
      var isTemple = row.cells[0].textContent.toLowerCase().indexOf('temple') !== -1;
      var val = (isTemple && temple)
        ? temple + ' mm'
        : (row.cells[colIdx] ? row.cells[colIdx].innerHTML.trim() : '');
      if (val && /^\d+(\.\d+)?$/.test(val)) val += ' mm';
      return '<tr><td>' + cleanLabel(row.cells[0].innerHTML) + '</td><td>' + val + '</td></tr>';
    }).join('');
  }

  /* Header row: Size* | <b>value</b> */
  function sizeHeaderRow(val) {
    return '<tr><td>Size*</td><td><b>' + val + '</b></td></tr>';
  }

  /* Sizes from variant metafields (snippets/hg-frame-sizes.liquid → #hg-frame-sizes-json).
     Returns the selected variant's row, or null if the product has no size metafields. */
  var FS_ROWS = [['a_size', 'Horizontal Lens Measurement, A'], ['b_size', 'Vertical Lens Measurement, B'],
    ['bridge', 'Bridge / Distance Between Lenses'], ['eld', 'Effective Lens Diameter, ED'],
    ['temple', 'Temple Length'], ['frame_width', 'Frame Width']];
  function getFrameSizesRow() {
    var el = document.getElementById('hg-frame-sizes-json');
    if (!el) return null;
    var data;
    try { data = JSON.parse(el.textContent); } catch (e) { return null; }
    var inp = document.querySelector('form[action*="/cart/add"] input[name="id"]') || document.querySelector('input[name="id"]');
    var row = inp ? data[inp.value] : null;
    if (!row) { for (var id in data) { row = data[id]; break; } }
    if (!row) return null;
    for (var i = 0; i < FS_ROWS.length; i++) { if (row[FS_ROWS[i][0]] != null) return row; }
    return null;
  }
  function fmtMm(v) { var n = Number(v); return (Math.round(n * 10) / 10) + ' mm'; }

  /* --- checkSizeGuideVisibility --- */
  window.checkSizeGuideVisibility = function() {
    if (getFrameSizesRow()) { var b0 = document.querySelector('.productSize'); if (b0) b0.style.display = ''; return; }
    var srcTable = findSrcSizeTable();
    var tableUsable = srcTable
      ? srcTable.querySelectorAll('tbody tr:first-child td').length >= 2
      : false;
    var hasSizeOpt = false, hasTempleOpt = false;
    document.querySelectorAll('.variantOption label').forEach(function(lbl) {
      var t = lbl.textContent.trim();
      if (t === 'Size') hasSizeOpt = true;
      if (t === 'Temple') hasTempleOpt = true;
    });
    var btn = document.querySelector('.productSize');
    if (btn) btn.style.display =
      (tableUsable || hasSizeOpt || hasTempleOpt || !!getSizeFromH1()) ? '' : 'none';
  };

  /* --- fillSizeTable --- */
  window.fillSizeTable = function() {
    var tbody = document.querySelector('.sizeTable tbody');
    if (!tbody) return;

    /* 0. Variant metafields win over the description table */
    var fs = getFrameSizesRow();
    if (fs) {
      var fsHtml = sizeHeaderRow(String(fs.k || '').replace(/size/i, '').replace(/\.0$/, '').trim() || '—');
      FS_ROWS.forEach(function(r) {
        if (fs[r[0]] != null) fsHtml += '<tr><td>' + r[1] + '</td><td>' + fmtMm(fs[r[0]]) + '</td></tr>';
      });
      tbody.innerHTML = fsHtml;
      return;
    }

    /* 1. Determine effective size: variant → H1 fallback */
    var selectedSize = getSelectedOptionVal('Size');
    var effectiveSize = selectedSize || getSizeFromH1();

    /* 2. Temple: extract number from e.g. "Cable 150mm" → "150" */
    var templeRaw = getSelectedOptionVal('Temple');
    var selectedTemple = null;
    if (templeRaw) { var tm = templeRaw.match(/(\d+)/); if (tm) selectedTemple = tm[1]; }

    /* 3. size_table from product description */
    var srcTable = findSrcSizeTable();
    var srcRows = srcTable ? Array.from(srcTable.querySelectorAll('tbody tr')) : [];
    var headerCells = (srcRows.length) ? Array.from(srcRows[0].querySelectorAll('td')) : [];

    /* 4. Find matching column */
    var colIdx = (srcTable && effectiveSize) ? findColIdx(headerCells, effectiveSize) : -1;

    var html = '';

    if (srcTable && colIdx !== -1) {
      /* ✓ Table found, size column matched → show full column */
      var szEl = headerCells[colIdx].querySelector('b');
      html += sizeHeaderRow(szEl ? szEl.textContent.trim() : headerCells[colIdx].textContent.trim());
      html += renderTableCol(srcRows, colIdx, selectedTemple);

    } else if (effectiveSize || selectedTemple) {
      /* ✓ Have size (variant/H1) or temple, but no table match → minimal rows */
      html += sizeHeaderRow(effectiveSize || '—');
      if (effectiveSize) html += '<tr><td>Horizontal Lens Measurement, A</td><td>' + effectiveSize + ' mm</td></tr>';
      if (selectedTemple) html += '<tr><td>Temple Length</td><td>' + selectedTemple + ' mm</td></tr>';

    } else if (srcTable && headerCells.length >= 2) {
      /* ✓ No size/temple at all — try H1 match in table, else show first column */
      var fallbackIdx = 1;
      var h1Size = getSizeFromH1();
      if (h1Size) { var fi = findColIdx(headerCells, h1Size); if (fi !== -1) fallbackIdx = fi; }
      var fbEl = headerCells[fallbackIdx].querySelector('b');
      html += sizeHeaderRow(fbEl ? fbEl.textContent.trim() : headerCells[fallbackIdx].textContent.trim());
      html += renderTableCol(srcRows, fallbackIdx, selectedTemple);

    } else {
      /* ✗ Nothing to show — hide button */
      tbody.innerHTML = '';
      var btn = document.querySelector('.productSize');
      if (btn) btn.style.display = 'none';
      return;
    }

    tbody.innerHTML = html;
  };
  window.toggleSizeGuide = function() {
    window.fillSizeTable();
    var m = document.getElementById('sizeGuideModal');
    if (m) {
      var sizeImgUrl = (m.getAttribute('data-size-img') || '').trim();
      var srcTable   = findSrcSizeTable();
      var defDiagram = document.getElementById('diagramDefault');
      var sizeImgDiv = document.getElementById('diagramSizeImg');
      var sizeImgEl  = document.getElementById('diagramSizeImgEl');
      if (sizeImgUrl && !srcTable) {
        if (sizeImgEl) sizeImgEl.src = sizeImgUrl;
        if (defDiagram) defDiagram.style.display = 'none';
        if (sizeImgDiv) sizeImgDiv.style.display = '';
      } else {
        if (defDiagram) defDiagram.style.display = '';
        if (sizeImgDiv) sizeImgDiv.style.display = 'none';
      }
      m.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
  };
  window.closeSizeGuide = function(e) {
    if (e && e.target !== e.currentTarget) return;
    var m = document.getElementById('sizeGuideModal');
    if (m) { m.style.display = 'none'; document.body.style.overflow = ''; }
  };
  // wishlist toggle handled by wishlist-drawer.liquid (wishlistToggle)

  /* ── Price formatting: market currency, 2 decimals (no rate multiplication — Shopify Markets handles conversion server-side) ──
     Currency-aware via rxapp-market-rate.js (loaded before this file); falls
     back to hardcoded $ only if that script failed to load. */
  function _hgFormatRounded(baseCents) {
    if (typeof window.__rxappFormatMoney === 'function') {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active)
        || document.documentElement.getAttribute('data-shop-currency');
      return window.__rxappFormatMoney(Math.round(baseCents), cur);
    }
    return '$' + (Math.round(baseCents) / 100).toFixed(2);
  }
  /* LensKit-tagged products: "4th lens FREE" badge instead of the generic %-off badge */
  var _hgFreeLensBadge = _hgSwatchData.freeLensBadge;
  function _hgSetBadgeAndSavings(badgeEl, onSale, compareAtCents, priceCents) {
    if (!onSale) {
      if (badgeEl) { badgeEl.textContent = ''; badgeEl.style.display = 'none'; }
      return;
    }
    if (_hgFreeLensBadge) {
      var savings = _hgFormatRounded(compareAtCents - priceCents);
      if (badgeEl) { badgeEl.textContent = '4th lens FREE — save ' + savings; badgeEl.style.display = ''; }
    } else {
      var disc = Math.round((compareAtCents - priceCents) * 100 / compareAtCents);
      if (badgeEl) { badgeEl.textContent = 'SALE ' + disc + '% OFF'; badgeEl.style.display = ''; }
    }
  }
  function _hgUpdateButtonPrices(variantBaseCents) {
    document.querySelectorAll('.btnAddToCart strong').forEach(function(el) {
      el.textContent = _hgFormatRounded(variantBaseCents);
    });
  }
  /* Group header ("Clip Only" / "Complete Eyeglasses with Clip-on"): hide it when
     every item of its group is hidden as unavailable */
  function _hgSyncGroupLabels(swatch) {
    swatch.querySelectorAll('.variantSwatchGroupLabel').forEach(function(label) {
      var vis = false;
      for (var el = label.nextElementSibling; el && !el.classList.contains('variantSwatchGroupLabel'); el = el.nextElementSibling) {
        if (el.style.display !== 'none') { vis = true; break; }
      }
      label.style.display = vis ? '' : 'none';
    });
  }
  function _hgSetBtnState(canOrder, price) {
    document.querySelectorAll('.btnAddToCart').forEach(function(btn) {
      btn.disabled = !canOrder;
      if (!canOrder) {
        btn.innerHTML = _hgSwatchData.soldOutLabel;
      } else {
        /* Markup already in the orderable state (server render) — only the
           price changes; rebuilding innerHTML on load re-flowed the button */
        var priceEl = btn.querySelector('.btnAddToCart__price strong');
        if (priceEl) {
          priceEl.setAttribute('data-price', price);
          priceEl.textContent = _hgFormatRounded(price);
          return;
        }
        var label = btn.getAttribute('data-label') || 'Add to cart';
        var labelMobile = btn.getAttribute('data-label-mobile') || label;
        btn.innerHTML = '<span class="btnAddToCart__label btnAddToCart__label--desktop">' + label + '</span>' +
          '<span class="btnAddToCart__label btnAddToCart__label--mobile">' + labelMobile + '</span>' +
          '<span class="btnAddToCart__price"><strong data-price="' + price + '">' + _hgFormatRounded(price) + '</strong></span>';
      }
    });
    document.querySelectorAll('.btnPrescription').forEach(function(btn) {
      btn.style.display = canOrder ? '' : 'none';
    });
    if (canOrder) {
      _hgUpdateButtonPrices(price);
      /* Rx button: update the frame-price attribute and let
         rxapp-market-rate.js recompute with the cached rate — no new
         fetch, the rate doesn't change between variants of the same
         product (see rxapp-market-rate.js header comment). */
      var variantInput = document.querySelector('input[name="id"]');
      document.querySelectorAll('.btnPrescription[data-prescription-addon]').forEach(function(btn) {
        btn.setAttribute('data-price', price);
        /* frame-only "from" (rxapp-market-rate.js) is looked up by variant */
        if (variantInput && variantInput.value) btn.setAttribute('data-variant-id', variantInput.value);
      });
      if (typeof window.__rxappUpdateRxButtons === 'function') {
        window.__rxappUpdateRxButtons();
      } else {
        document.querySelectorAll('.btnPrescription[data-prescription-addon]').forEach(function(btn) {
          var addon = parseInt(btn.getAttribute('data-prescription-addon') || '0', 10);
          var strong = btn.querySelector('strong');
          if (strong) strong.textContent = _hgFormatRounded(price + addon);
        });
      }
    }
  }

  /* Lead time (custom.lead_time): show backorder / coming-soon note for the selected variant.
     Data + translated texts are rendered by snippets/hg-lead-time.liquid. */
  var _hgLeadTimeMap = null;
  function _hgUpdateLeadTime(variant) {
    var box = document.getElementById('hg-lead-time');
    if (!box || !variant) return;
    if (_hgLeadTimeMap === null) {
      var el = document.getElementById('hg-lead-time-json');
      try { _hgLeadTimeMap = el ? JSON.parse(el.textContent) : {}; } catch (e) { _hgLeadTimeMap = {}; }
    }
    var info = _hgLeadTimeMap[variant.id];
    // Вкладка Shipping (Ray-Ban): срок выбранного цвета вместо «USA 5-15 business days»; пусто — строку прячем.
    var tab = document.querySelector('[data-hg-ship-tab]');
    if (tab) {
      tab.hidden = !(info && info.s);
      if (info && info.s) tab.querySelector('[data-hg-ship-tab-text]').textContent = info.s;
    }
    box.classList.remove('hg-leadtime--backorder', 'hg-leadtime--coming-soon', 'hg-leadtime--in-stock');
    if (!info) { box.hidden = true; return; }
    box.classList.add('hg-leadtime--' + info.k);
    var main = box.querySelector('.hg-leadtime__main'), rx = box.querySelector('.hg-leadtime__rx');
    if (main) main.textContent = info.t; else box.querySelector('.hg-leadtime__text').textContent = info.t;
    if (rx) { rx.textContent = info.x || ''; rx.hidden = !info.x; }
    box.hidden = false;
  }

  /* Back-in-stock: toggle email form vs buy buttons.
     Form shows ONLY when ALL product variants are OOS — partial OOS just hides unavailable
     options from the picker, no form. */
  function _hgUpdateBackInStock(variant) {
    var wrap = document.querySelector('.hg-bis-wrapper');
    var addWrap = document.querySelector('.hg-addbuttons-wrapper');
    if (!wrap || !addWrap) return;
    if (!variant) return;
    var variantsEl = document.getElementById('product-variants-json');
    var allVariants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var allOOS = allVariants.length > 0 && allVariants.every(function(v) {
      return !v.available && !(v.inventory_quantity != null && v.inventory_quantity > 0);
    });
    wrap.hidden = !allOOS;
    addWrap.hidden = allOOS;
    if (allOOS) {
      var sku = variant.sku || ('id-' + variant.id);
      var tagInput = wrap.querySelector('.hg-bis-tags');
      if (tagInput) tagInput.value = 'bis,bis-' + sku;
      var skuSpan = wrap.querySelector('.hg-bis-sku');
      if (skuSpan) skuSpan.textContent = variant.sku ? '(' + variant.sku + ')' : '';
      /* Reset form state for the new variant */
      var field = wrap.querySelector('.hg-coming-soon-field');
      var success = wrap.querySelector('.hg-coming-soon-success');
      var error = wrap.querySelector('.hg-coming-soon-error');
      var btn = wrap.querySelector('.hg-coming-soon-btn');
      var emailInput = wrap.querySelector('.hg-coming-soon-input');
      if (field) field.hidden = false;
      if (success) success.hidden = true;
      if (error) { error.hidden = true; error.textContent = ''; }
      if (btn) { btn.disabled = false; btn.textContent = 'Notify me'; }
      if (emailInput) emailInput.value = '';
    }
  }

  /* AJAX submit for BIS / Coming Soon forms — no page scroll, inline feedback */
  (function() {
    function _hgSetupAjaxForm(form) {
      if (!form || form.dataset.hgAjax) return;
      form.dataset.hgAjax = '1';
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var emailInput = form.querySelector('.hg-coming-soon-input');
        var btn        = form.querySelector('.hg-coming-soon-btn');
        var field      = form.querySelector('.hg-coming-soon-field');
        var success    = form.querySelector('.hg-coming-soon-success');
        var error      = form.querySelector('.hg-coming-soon-error');
        if (!emailInput || !emailInput.validity.valid) { if (emailInput) emailInput.focus(); return; }
        btn.disabled = true;
        btn.textContent = '...';
        if (error) { error.hidden = true; error.textContent = ''; }
        fetch('/contact', { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function() {
            if (field) field.hidden = true;
            if (success) success.hidden = false;
          })
          .catch(function() {
            btn.disabled = false;
            btn.textContent = 'Notify me';
            if (error) { error.textContent = 'Something went wrong. Please try again.'; error.hidden = false; }
          });
      });
    }
    function _hgInitAjaxForms() {
      document.querySelectorAll('.hg-coming-soon-form').forEach(_hgSetupAjaxForm);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', _hgInitAjaxForms);
    } else {
      _hgInitAjaxForms();
    }
  })();

  window.updateProductVariant = function() {
    var selects = document.querySelectorAll('select[data-option-index]');
    /* Map by data-option-index so single-value options (which have no select)
       don't shift the array and break variant matching */
    var selectedByIdx = {};
    selects.forEach(function(s) {
      var idx = parseInt(s.getAttribute('data-option-index'), 10);
      selectedByIdx[idx] = s.value;
    });
    var el = document.getElementById('product-variants-json');
    if (!el) return;
    var variants = JSON.parse(el.textContent);

    /* Rule: available=true OR inventory_quantity>0 */
    var unavailMode = (document.getElementById('variants') || {}).dataset
      ? (document.getElementById('variants').dataset.unavailMode || 'hide') : 'hide';

    /* True when every variant in the product is OOS — used in notify mode to keep
       the picker visible (customer chooses which variant to subscribe to) */
    var allOOS = unavailMode === 'notify' && variants.length > 0 && variants.every(function(v) {
      return !v.available && !(v.inventory_quantity != null && v.inventory_quantity > 0);
    });

    /* Cascading availability: option[i] is filtered only by current selection of options[0..i-1].
       This ensures selecting Frame Color=Black limits Lens Color to combos with Black,
       while Frame Color itself is always shown independently. */
    function hasAvailableVariant(optIdx, val) {
      return variants.some(function(v) {
        var canOrder = v.available || (v.inventory_quantity != null && v.inventory_quantity > 0);
        if (!canOrder || v.options[optIdx] !== val) return false;
        for (var i = 0; i < optIdx; i++) {
          if (i in selectedByIdx && v.options[i] !== selectedByIdx[i]) return false;
        }
        return true;
      });
    }

    /* Find max option index across all controls */
    var maxOptIdx = 0;
    document.querySelectorAll('[data-option-index]').forEach(function(node) {
      var i = parseInt(node.getAttribute('data-option-index'), 10);
      if (i > maxOptIdx) maxOptIdx = i;
    });

    /* Process options in ascending index order so each update uses latest selectedByIdx */
    for (var oi = 0; oi <= maxOptIdx; oi++) {
      /* Pill buttons */
      document.querySelectorAll('.variantPills').forEach(function(container) {
        var firstBtn = container.querySelector('[data-option-index]');
        if (!firstBtn) return;
        var optIdx = parseInt(firstBtn.getAttribute('data-option-index'), 10);
        if (optIdx !== oi) return;
        container.querySelectorAll('.variantPillBtn').forEach(function(btn) {
          var avail = hasAvailableVariant(optIdx, btn.getAttribute('data-value'));
          /* In full OOS notify mode don't mark as unavailable — customer needs to pick which variant to subscribe to */
          btn.classList.toggle('variantPillBtnUnavailable', !avail && !(allOOS && unavailMode === 'notify'));
          /* Notify+fullOOS: show all (customer picks variant to subscribe to);
             Notify+partialOOS or hide: hide unavailable */
          btn.style.display = (!avail && (unavailMode === 'hide' || (unavailMode === 'notify' && !allOOS))) ? 'none' : '';
        });
        /* Auto-reselect if selected pill is unavailable — only in partial OOS (full OOS: let customer choose) */
        var selPill = container.querySelector('.variantPillBtnSelected');
        if (!allOOS && selPill && selPill.classList.contains('variantPillBtnUnavailable')) {
          var pillSel = container.querySelector('select[data-option-index="' + optIdx + '"]');
          var firstAvail = null;
          container.querySelectorAll('.variantPillBtn').forEach(function(b) { if (!firstAvail && !b.classList.contains('variantPillBtnUnavailable')) firstAvail = b; });
          if (firstAvail && pillSel) {
            container.querySelectorAll('.variantPillBtn').forEach(function(b) { b.classList.remove('variantPillBtnSelected'); });
            firstAvail.classList.add('variantPillBtnSelected');
            pillSel.value = firstAvail.getAttribute('data-value');
            selectedByIdx[optIdx] = pillSel.value;
          }
        }
      });
      /* Swatch items */
      document.querySelectorAll('.variantSwatch').forEach(function(swatch) {
        var optIdx = parseInt(swatch.getAttribute('data-option-index'), 10);
        if (optIdx !== oi) return;
        var swSelect = swatch.querySelector('.variantSwatchSelect');
        swatch.querySelectorAll('.variantSwatchItem').forEach(function(item) {
          var avail = hasAvailableVariant(optIdx, item.getAttribute('data-value'));
          /* In full OOS notify mode don't mark as unavailable — prevents CSS :has() from blocking the trigger */
          item.classList.toggle('variantSwatchItemUnavailable', !avail && !(allOOS && unavailMode === 'notify'));
          item.style.display = (!avail && (unavailMode === 'hide' || (unavailMode === 'notify' && !allOOS))) ? 'none' : '';
        });
        _hgSyncGroupLabels(swatch);
        /* Auto-reselect if selected swatch is unavailable — only in partial OOS */
        var selItem = swatch.querySelector('.variantSwatchItem.variantSwatchItemSelected');
        if (!allOOS && selItem && selItem.classList.contains('variantSwatchItemUnavailable')) {
          var firstAvail = null;
          swatch.querySelectorAll('.variantSwatchItem').forEach(function(i) { if (!firstAvail && !i.classList.contains('variantSwatchItemUnavailable')) firstAvail = i; });
          if (firstAvail) {
            swatch.querySelectorAll('.variantSwatchItem').forEach(function(i) {
              i.classList.toggle('variantSwatchItemSelected', i === firstAvail);
              i.setAttribute('aria-selected', String(i === firstAvail));
            });
            if (swSelect) {
              swSelect.value = firstAvail.getAttribute('data-value');
              selectedByIdx[optIdx] = swSelect.value;
            }
            var trigImg = swatch.querySelector('.variantSwatchImg');
            var trigLbl = swatch.querySelector('.variantSwatchLabel');
            var newImg = firstAvail.querySelector('img');
            if (trigImg && newImg) { trigImg.src = newImg.src; trigImg.alt = newImg.alt; }
            if (trigLbl) trigLbl.innerHTML = window.hgSwatchLabelHTML((firstAvail.querySelector('span:not(.variantSwatchImgEmpty)') || {}).textContent || '');
          }
        }
        /* Block trigger when all items are unavailable (not in notify mode — customer must be able to pick) */
        var swTrigger = swatch.querySelector('.variantSwatchTrigger');
        if (swTrigger) {
          var totalItems = swatch.querySelectorAll('.variantSwatchItem').length;
          var unavailItems = swatch.querySelectorAll('.variantSwatchItem.variantSwatchItemUnavailable').length;
          var allUnavail = totalItems > 0 && unavailItems === totalItems;
          var blockTrigger = allUnavail && unavailMode !== 'notify';
          swTrigger.style.display = '';
          /* Use explicit 'auto' to override CSS :has() rule that blocks trigger when selected item is OOS */
          swTrigger.style.pointerEvents = blockTrigger ? 'none' : 'auto';
          swTrigger.style.opacity = blockTrigger ? '0.45' : '';
          swTrigger.style.cursor = blockTrigger ? 'not-allowed' : '';
        }
      });
    }

    /* Downgrade to "locked" static look when only 1 value is actually purchasable —
       declared values > 1, but availability filtering above left just one visible/enabled.
       Same treatment as a true single-value option: no arrow/dropdown, nothing to switch to.
       Skip in 'notify' mode — there the customer must still be able to pick an OOS variant. */
    if (unavailMode !== 'notify') {
      document.querySelectorAll('.variantPills').forEach(function(container) {
        var row = container.closest('.variantOption');
        if (!row) return;
        var visibleBtns = Array.prototype.filter.call(container.querySelectorAll('.variantPillBtn'), function(b) {
          return b.style.display !== 'none';
        });
        /* Nothing left to pick (e.g. fully discontinued item) — hide the whole
           row, label included, instead of leaving an empty "Size" caption. */
        row.style.display = visibleBtns.length === 0 ? 'none' : '';
        if (visibleBtns.length === 1) {
          row.classList.add('variantOptionSingle');
          visibleBtns[0].classList.add('variantPillBtnStatic');
        } else {
          row.classList.remove('variantOptionSingle');
          container.querySelectorAll('.variantPillBtn').forEach(function(b) { b.classList.remove('variantPillBtnStatic'); });
        }
      });
      document.querySelectorAll('.variantSwatch[data-option-index]').forEach(function(swatch) {
        var row = swatch.closest('.variantOption');
        if (!row) return;
        var visibleItems = Array.prototype.filter.call(swatch.querySelectorAll('.variantSwatchItem'), function(i) {
          return i.style.display !== 'none';
        });
        var trigger = swatch.querySelector('.variantSwatchTrigger');
        var arrow = swatch.querySelector('.variantSwatchArrow');
        var list = swatch.querySelector('.variantSwatchList');
        /* Nothing left to pick — hide the whole row, label included. */
        row.style.display = visibleItems.length === 0 ? 'none' : '';
        if (visibleItems.length === 1) {
          row.classList.add('variantOptionSingle');
          if (trigger) {
            trigger.classList.add('variantSwatchTriggerStatic');
            trigger.style.pointerEvents = 'none';
            trigger.style.cursor = 'default';
            trigger.style.opacity = '';
          }
          if (arrow) arrow.style.display = 'none';
          if (list) list.style.display = 'none';
        } else {
          row.classList.remove('variantOptionSingle');
          if (trigger) trigger.classList.remove('variantSwatchTriggerStatic');
          if (arrow) arrow.style.display = '';
          if (list) list.style.display = '';
        }
      });
    }

    /* Hide "Title" option rows; single-value options render statically (locked, no button) instead of hiding */
    document.querySelectorAll('.variantOption').forEach(function(row) {
      var lbl = row.querySelector('label');
      if (lbl && lbl.textContent.trim().toLowerCase().indexOf('title') !== -1) {
        row.style.display = 'none';
        return;
      }
      if (row.classList.contains('variantOptionSingle')) {
        row.style.display = '';
        return;
      }
      var items = row.querySelectorAll('.variantSwatchItem, .variantPillBtn');
      row.style.display = items.length <= 1 ? 'none' : '';
    });

    /* Find matching variant with up-to-date selectedByIdx (after potential auto-reselection) */
    var match = variants.find(function(v) {
      return v.options.every(function(opt, i) {
        /* If no select for this index it's a single-value option — any value matches */
        return !(i in selectedByIdx) || selectedByIdx[i] === opt;
      });
    });
    if (match) {
      var priceEl = document.getElementById('product-price');
      var compareEl = document.getElementById('product-compare-price');
      var badgeEl = document.getElementById('product-sale-badge');
      var onSale = match.compare_at_price && match.compare_at_price > match.price;
      if (priceEl) {
        priceEl.textContent = _hgFormatRounded(match.price);
        priceEl.className = onSale ? 'salePrice' : 'price';
      }
      if (compareEl) {
        if (onSale) {
          compareEl.textContent = _hgFormatRounded(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
      }
      _hgSetBadgeAndSavings(badgeEl, onSale, match.compare_at_price, match.price);
      var skuEl = document.getElementById('product-sku');
      if (skuEl) skuEl.innerHTML = match.sku ? '<span class="skuLabel">SKU: </span><span class="skuValue">' + match.sku.replace(/[<>&]/g, '') + '</span>' : '';
      var upcEl = document.getElementById('product-upc');
      if (upcEl) upcEl.innerHTML = match.barcode ? '<span class="skuLabel">UPC: </span><span class="skuValue">' + match.barcode.replace(/[<>&]/g, '') + '</span>' : '';
      var bbOptsEl = document.getElementById('bottomBarOptions');
      if (bbOptsEl) bbOptsEl.textContent = match.options.join(' / ');
      document.querySelectorAll('input[name="id"]').forEach(function(inp) { inp.value = match.id; });
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      history.replaceState({}, '', url.toString());
      var canOrder = match.available || match.inventory_quantity > 0;
      _hgSetBtnState(canOrder, match.price);
      _hgUpdateBackInStock(match);
      _hgUpdateLeadTime(match);
      /* hg-waiver.liquid: show/hide the waiver checkbox for the new variant */
      document.dispatchEvent(new CustomEvent('hg:variant-change', { detail: { id: match.id } }));
      // Update gallery to show variant's images
      if (window.galleryFilterByVariant) {
        window.galleryFilterByVariant(match.id);
      } else if (match.featured_image && match.featured_image.src && window.gallerySetImageBySrc) {
        window.gallerySetImageBySrc(match.featured_image.src);
      }
      // Sync bottom bar thumbnail
      if (match.featured_image && match.featured_image.src) {
        var bbImg = document.querySelector('.bottomBarImage img');
        if (bbImg) {
          bbImg.src = match.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_100x$1$2');
        }
      }
    } else {
      _hgSetBtnState(false, 0);
      console.warn('[variant] no match for options:', selectedByIdx);
    }
  };
  /* ── Init button prices on page load (applies currency rate if active) ── */
  (function() {
    function initButtonPrices() {
      var el = document.getElementById('product-variants-json');
      if (!el) return;
      var vs = JSON.parse(el.textContent);
      var initId = parseInt(thisVariantId, 10);
      var initV = vs.find(function(v) { return v.id === initId; });
      if (initV) {
        var canOrder = initV.available || initV.inventory_quantity > 0;
        _hgSetBtnState(canOrder, initV.price);
        _hgUpdateBackInStock(initV);
        var initOnSale = initV.compare_at_price && initV.compare_at_price > initV.price;
        var initPriceEl = document.getElementById('product-price');
        var initCompareEl = document.getElementById('product-compare-price');
        var initBadgeEl = document.getElementById('product-sale-badge');
        if (initPriceEl) initPriceEl.className = initOnSale ? 'salePrice' : 'price';
        if (initCompareEl) {
          if (initOnSale) {
            initCompareEl.textContent = _hgFormatRounded(initV.compare_at_price);
            initCompareEl.style.display = '';
          } else {
            initCompareEl.textContent = '';
            initCompareEl.style.display = 'none';
          }
        }
        _hgSetBadgeAndSavings(initBadgeEl, initOnSale, initV.compare_at_price, initV.price);
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initButtonPrices);
    } else {
      initButtonPrices();
    }
  })();

  document.addEventListener('keydown', function(e) {
    var im = document.getElementById('imageModal');
    if (im && im.style.display === 'flex') {
      if (e.key === 'ArrowLeft') window.modalPrevImage();
      if (e.key === 'ArrowRight') window.modalNextImage();
    }
    if (e.key === 'Escape') { window.closeSizeGuide(); window.closeImageModal(); }
  });

  // === Variant swatch dropdowns ===
  (function() {
    function initSwatches() {
      document.querySelectorAll('.variantSwatch').forEach(function(swatch) {
        var trigger = swatch.querySelector('.variantSwatchTrigger');
        var items = swatch.querySelectorAll('.variantSwatchItem');
        var select = swatch.querySelector('.variantSwatchSelect');
        var triggerImg = trigger.querySelector('.variantSwatchImg');
        var triggerLabel = trigger.querySelector('.variantSwatchLabel');

        /* Нет ни одной картинки — скрываем пустые плейсхолдеры во всём свотче */
        var hasAnyImg = Array.from(items).some(function(i) { return !!i.querySelector('img'); });
        if (!hasAnyImg) swatch.classList.add('variantSwatch--textOnly');

        trigger.addEventListener('click', function(e) {
          e.stopPropagation();
          var isOpen = swatch.classList.contains('open');
          document.querySelectorAll('.variantSwatch.open').forEach(function(s) { s.classList.remove('open'); });
          if (!isOpen) swatch.classList.add('open');
        });

        items.forEach(function(item) {
          item.addEventListener('click', function() {
            var value = item.getAttribute('data-value');
            var img = item.querySelector('img');
            // Update trigger
            if (img) {
              if (triggerImg) { triggerImg.src = img.src; triggerImg.alt = img.alt; }
              else {
                var empty = trigger.querySelector('.variantSwatchImgEmpty');
                if (empty) { var ni = document.createElement('img'); ni.className = 'variantSwatchImg'; ni.width = 41; ni.height = 41; ni.src = img.src; ni.alt = img.alt; empty.parentNode.replaceChild(ni, empty); triggerImg = ni; }
              }
            }
            if (triggerLabel) triggerLabel.innerHTML = window.hgSwatchLabelHTML((item.querySelector('span:not(.variantSwatchImgEmpty)') || {}).textContent || '');
            // Update selected state
            items.forEach(function(i) { i.classList.remove('variantSwatchItemSelected'); i.setAttribute('aria-selected', 'false'); });
            item.classList.add('variantSwatchItemSelected');
            item.setAttribute('aria-selected', 'true');
            // Sync hidden select
            select.value = value;
            swatch.classList.remove('open');
            if (window.updateProductVariant) window.updateProductVariant();
          });
        });
      });

      document.addEventListener('click', function() {
        document.querySelectorAll('.variantSwatch.open').forEach(function(s) { s.classList.remove('open'); });
      });

      // Pill buttons
      document.querySelectorAll('.variantPillBtn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var value = btn.getAttribute('data-value');
          var optIdx = btn.getAttribute('data-option-index');
          var container = btn.closest('.variantPills');
          container.querySelectorAll('.variantPillBtn').forEach(function(b) { b.classList.remove('variantPillBtnSelected'); });
          btn.classList.add('variantPillBtnSelected');
          var sel = container.querySelector('select[data-option-index="' + optIdx + '"]');
          if (sel) sel.value = value;
          if (window.updateProductVariant) window.updateProductVariant();
        });
      });
    }

    function alignVariantLabels() {
      /* With subgrid the CSS in main-product.liquid aligns labels from first paint */
      if (window.CSS && CSS.supports('grid-template-columns', 'subgrid')) return;
      var labels = document.querySelectorAll('#variants .variantOption label');
      if (!labels.length) return;
      labels.forEach(function(l) { l.style.width = 'auto'; });
      var maxW = 0;
      labels.forEach(function(l) { if (l.offsetWidth > maxW) maxW = l.offsetWidth; });
      labels.forEach(function(l) { l.style.width = maxW + 'px'; });
    }

    function initBottomBar() {
      var bar = document.getElementById('bottomBar');
      if (!bar) return;
      var mainButtons = document.querySelector('.productInfo .buttons');
      if (!mainButtons) return;
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            bar.style.transform = 'translateY(100%)';
          } else {
            bar.style.transform = 'translateY(0)';
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });
      observer.observe(mainButtons);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { initSwatches(); if (window.updateProductVariant) window.updateProductVariant(); alignVariantLabels(); initBottomBar(); if (window.checkSizeGuideVisibility) window.checkSizeGuideVisibility(); });
    } else {
      initSwatches();
      if (window.updateProductVariant) window.updateProductVariant();
      alignVariantLabels();
      initBottomBar();
    }
  })();
})();
